<div class="relative w-full grow-1 overflow-auto mb-[0] flex flex-col">
  <div class="grow-1 w-full min-h-0">
    <gc-chart  class="relative" type="bar" [data]="chartData()" [options]="chartOptions()" [plugins]="chartPlugins" />
  </div>
</div>
